import Header from '../../layout/Header';

const ErrorBoundary = () => {
  return (
    <div className=" w-full h-[100vh]">
      <Header />
      <div className="flex justify-center items-center h-full">
        <div>
          <h1 className="my-2 text-gray-800 font-bold text-2xl">
            {`We're currently making some updates.`}
          </h1>
          <p className="my-2 text-gray-800">Please check back in a moment.</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorBoundary;
